import React from 'react'
import PropTypes from 'prop-types'
import { Carousel } from 'antd-mobile'
import { _, Bridge, UtilCommon, UtilDevice } from '@iskytrip/sdk'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'
import iconBack from '@assets/icon/icon-back.png'
import iconShare from '@assets/icon/icon-share.png'
import iconBackBlack from '@assets/icon/icon-back-black.png'
import iconShareBlack from '@assets/icon/icon-share-black.png'
import playIcon from '@assets/icon/playIcon.png'

let video
let scrollTop

class NaviCarousel extends BaseComponent {
	state = {
		// 轮播图
		from: 0,
		to: 0,
		// 导航栏
		naviShow: false,
		isWatch: true,
		selectedIndex: 0,
		currentAnchor: {},
		currentType: 1, // 1-视频 2-图片
		signalBarHeight: 20, // 状态栏高度
		showNaviHeight: 64, // 超过该距离就显示导航栏
	}

	componentDidMount() {
		const self = this
		Bridge.appGetSignalBarHeight((height) => {
			self.setState(
				{
					signalBarHeight: height,
					showNaviHeight: height + 44,
				},
				function() {
					console.log(height + 44)
				},
			)
		})
		// 挂载滚动监听
		window.addEventListener('scroll', this.handleScroll.bind(this))
		document.addEventListener('fullscreenchange', this.handleFullscreen.bind(this))
	}

	componentWillUnmount() {
		// 移除滚动监听
		window.removeEventListener('scroll', this.handleScroll.bind(this))
		document.removeEventListener('fullscreenchange', this.handleFullscreen.bind(this))
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.index !== this.props.index) {
			this.setState({
				selectedIndex: this.props.index,
			})
		}
	}

	handleScroll() {
		// 获取滚动距离
		let scrollTop = document.documentElement.scrollTop // 滚动条滚动高度
		if (scrollTop === 0) {
			scrollTop = document.body.scrollTop // 滚动条滚动高度
		}
		// console.log('---- scrollTop', scrollTop)
		// 获取第一个锚点,用于判断是否显示导航栏
		let anchors = this.props.anchors || []
		let showNaviHeight = 150
		if (anchors.length > 0) {
			let item = anchors[0]
			let anchorElement = document.getElementById(item.anchorId)
			if (_.isHasValue(anchorElement)) {
				showNaviHeight = anchorElement.offsetTop
			}
		}
		// 是否显示导航栏,对应锚点显示选中样式
		// -1 是为了防止点击第一个锚点的时候,导航栏隐藏
		if (scrollTop >= showNaviHeight - 1) {
			this.setState({
				naviShow: true,
			})
			if (this.state.isWatch) {
				for (let i = 0; i < anchors.length; i++) {
					let item = anchors[i]
					let anchorElement = document.getElementById(item.anchorId)
					// console.log('-------- offsetTop', anchorElement.offsetTop)
					if (_.isHasValue(anchorElement)) {
						if (scrollTop >= anchorElement.offsetTop) {
							this.setState({
								currentAnchor: item,
							})
						}
					}
				}
			}
		} else {
			this.setState({
				naviShow: false,
			})
		}
	}

	handleFullscreen() {
		if (document.fullscreenElement) {
			console.log('进入全屏')
			scrollTop = document.documentElement.scrollTop // 滚动条滚动高度
			if (scrollTop === 0) {
				scrollTop = document.body.scrollTop // 滚动条滚动高度
			}
			video.play()
			video.controls = true
		} else {
			console.log('退出全屏')
			document.documentElement.scrollTop = scrollTop
			video.pause()
			video.controls = false
		}
	}

	scrollToAnchor = (anchor) => {
		if (anchor) {
			// 找到锚点
			let anchorElement = document.getElementById(anchor.anchorId)
			// 如果对应id的锚点存在,就滚动到锚点
			if (anchorElement) {
				anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
			}
			// 设置选中样式
			const self = this
			this.setState(
				{
					currentAnchor: anchor,
					isWatch: false,
				},
				function() {
					setTimeout(function() {
						self.setState({
							isWatch: true,
						})
					}, 500)
				},
			)
		}
	}

	selectType(type) {
		if (type !== this.state.currentType) {
			let videoDetails = this.props.videoDetails || []
			this.setState({
				currentType: type,
				selectedIndex: type === 1 ? 0 : videoDetails.length,
			})
		}
	}

	detail(type, item, index) {
		console.log(type, item)
		if (type === 1 && UtilDevice.isIOS()) {
			// iOS的视频可以这么播放
			let idStr = 'video' + index
			video = document.getElementById(idStr)
			if (video.paused) {
				video.play()
			} else {
				video.pause()
			}
			if (video.requestFullscreen) {
				video.requestFullscreen()
			} else if (video.mozRequestFullScreen) {
				video.mozRequestFullScreen()
			} else if (video.webkitRequestFullScreen) {
				video.webkitRequestFullScreen()
			}
			return
		}
		this.props.detail && this.props.detail(type, item, index)
	}

	afterChange(number) {
		let videoDetails = this.props.videoDetails || []
		let currentType = 2
		if (number < videoDetails.length) {
			currentType = 1
		}
		this.setState({
			selectedIndex: number,
			currentType,
		})
	}

	render() {
		let imageDetails = this.props.imageDetails || []
		let videoDetails = this.props.videoDetails || []
		let anchors = this.props.anchors || []
		let currentAnchor = this.state.currentAnchor || {}
		let currentType = this.state.currentType || 1
		let selectedIndex = this.state.selectedIndex || 0
		if (imageDetails.length === 0) {
			currentType = 1
		}
		if (videoDetails.length === 0) {
			currentType = 2
		}
		// 视频排在前面,图片排在后面
		let details = []
		videoDetails.map((item) => {
			item.type = 1
			details.push(item)
		})
		imageDetails.map((item) => {
			item.type = 2
			details.push(item)
		})
		// 锚点宽度
		let anchorsWidth = '20%'
		if (anchors && anchors.length > 5) {
			anchorsWidth = 100 / anchors.length + '%'
		}
		return (
			<div className={CSS.titleSection}>
				<Carousel
					style={{
						width: '100%',
						height: '100%',
					}}
					selectedIndex={selectedIndex}
					infinite={true}
					autoplay={false}
					dots={false}
					beforeChange={(from, to) => this.setState({ from: from, to: to })}
					afterChange={this.afterChange.bind(this)}
				>
					{details.map((item, index) => {
						if (item.type === 1) {
							return (
								<div
									key={index}
									className={CSS.videoItem}
									onClick={this.detail.bind(this, 1, item, index)}
								>
									<video
										id={'video' + index}
										poster={item.preView}
										controlsList='nodownload nofullscreen noremoteplayback'
									>
										<source
											// src='https://static.iskytrip.com/activity/springfestival_20200115/image/video.mp4'
											src={item.videoUrl || ''}
											type='video/mp4'
										/>
									</video>
									<img src={item.preView || ''} alt='' />
									<img src={playIcon} alt='' />
								</div>
							)
						} else {
							return (
								<div
									key={index}
									style={{
										display: 'inline-block',
										width: '100%',
										height: '5rem',
									}}
									onClick={this.detail.bind(this, 2, item, index)}
								>
									<div
										style={{
											width: '100%',
											height: '5rem',
											backgroundImage:
												'url(' +
												UtilCommon.creatImgUrl(item.imageUrl, 1) +
												')',
											backgroundSize: 'cover',
										}}
									></div>
								</div>
							)
						}
					})}
				</Carousel>
				{/* 中间视频图片切换按钮 */}
				{imageDetails.length > 0 && videoDetails.length > 0 ? (
					<div className={CSS.carouselBtn}>
						<p
							className={currentType === 1 ? CSS.carouselBtnSelect : ''}
							onClick={this.selectType.bind(this, 1)}
						>
							视频
						</p>
						<p
							className={currentType === 2 ? CSS.carouselBtnSelect : ''}
							onClick={this.selectType.bind(this, 2)}
						>
							图片
						</p>
					</div>
				) : null}
				{/* 右下角滚动文案 */}
				<div className={CSS.carouselSec}>
					{this.state.to + 1}/{videoDetails.length + imageDetails.length}
				</div>
				{/* 导航栏 */}
				<div
					className={this.state.naviShow ? CSS.titleNavi2 : CSS.titleNavi1}
					style={{
						paddingTop: `${this.state.signalBarHeight}px`,
						boxSizing: 'content-box',
					}}
				>
					<img
						style={{ marginTop: `${this.state.signalBarHeight}px` }}
						className={CSS.titleNaviBack}
						src={this.state.naviShow ? iconBackBlack : iconBack}
						onClick={this.props.back}
						alt=''
					/>
					<img
						style={{ marginTop: `${this.state.signalBarHeight}px` }}
						className={this.state.naviShow ? CSS.titleNaviShare2 : CSS.titleNaviShare1}
						src={this.state.naviShow ? iconShareBlack : iconShare}
						onClick={this.props.share}
						alt=''
					/>
					<div
						className={this.state.naviShow ? CSS.titleNaviInner2 : CSS.titleNaviInner1}
					>
						{anchors.map((item, index) => (
							<span key={index} onClick={() => this.scrollToAnchor(item)}>
								<p
									className={
										currentAnchor.anchorId === item.anchorId
											? CSS.naviTitleItemBold
											: CSS.naviTitleItem
									}
									style={{ width: anchorsWidth }}
								>
									{item.anchorName}
								</p>
							</span>
						))}
					</div>
				</div>
			</div>
		)
	}
}

NaviCarousel.propTypes = {
	imageDetails: PropTypes.array.isRequired,
	anchors: PropTypes.array.isRequired,
}

export default NaviCarousel
